import React from 'react';
import './index.scss';

const Loader = () => {
  return (
    <div className="k-loading-mask app-loader">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
    </div>
  );
};

export default Loader;